module.exports = __webpack_public_path__ + "static/media/thermohug-3.996e40ef.jpg";